<form [formGroup]="form">
  <mat-dialog-content>
    <mat-form-field class="full-width" *ngIf="data.enableCustomCode">
      <mat-label> {{ 'label.invite_code' | translate }} </mat-label>
      <input matInput type="string" formControlName="code" />
      <mat-hint> {{ 'hint.invite_code' | translate }}</mat-hint>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label> {{ 'core.uses' | translate }} </mat-label>
      <input matInput type="number" formControlName="uses" />
      <mat-hint> {{ 'hint.invite_user_limit' | translate }}</mat-hint>
    </mat-form-field>
    <div class="text-uppercase workspace-label">
      {{ 'title.workspaces' | translate }} ({{ 'core.optional' | translate }})
    </div>
    <ts-workspace-selector *ngIf="{
        options: data.workspaces$ | async,
        selected: selected,
        totalSelected: selected.length,
        total: data.totalWorkspaces$ | async,
        loaded: (data.hasMoreItems$ | async) === false,
        hasMore: data.hasMoreItems$ | async
      } as state" [options]="state.options" [selected]="state.selected" [totalSelected]="state.totalSelected"
      [totalAvailable]="state.total" [loaded]="state.loaded" (lastItemReached)="lastItemReached.emit()"
      (selectAllAcrossPages)="selectAllWorkspacesRequested.emit()" [searchTerm]="data.workspaceSearchTerm$ | async"
      (searchTermChanged)="workspaceSearchTermChanged.emit($event)" (added)="markWorkspace($event)"
      (removed)="unmarkWorkspace($event)"></ts-workspace-selector>
    <label>{{ 'label.invite_initial_roles' | translate }}</label>
    <div class="align-items-center justify-content-center two-column-grid" *ngIf="data.roles$ | async as roles">
      <button class="btn m-1" *ngFor="let role of roles"
        [class.btn-outline-primary]="!form.controls['initialRoles'].value.includes(role)"
        [class.btn-primary]="form.controls['initialRoles'].value.includes(role)" [disabled]="!role.available"
        (click)="toggleRole(form.controls['initialRoles'], role)" data-cy="button-toggle-invite-role">
        {{ role.name | translate }}
      </button>
      <mat-spinner *ngIf="!roles.length"></mat-spinner>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-center">
    <button class="btn btn-outline-danger m-2" type="cancel" (click)="cancel()" data-cy="button-cancel-invite">
      {{ 'button.cancel' | translate }}
    </button>
    <button class="btn btn-primary m-2" type="submit" (click)="submit()"
      [disabled]="form.controls['initialRoles'].value.length === 0" data-cy="button-save-invite">
      {{ 'button.create_invite_code' | translate }}
    </button>
  </mat-dialog-actions>
</form>